import { Suspense } from 'react';

import Page from '@components/page';
import PageLoader from '@components/page-loader';
import { RouteContainer } from '@components/router';

import type { AppShellProps } from './app-shell';
import AppShell from './app-shell';
import ClientInit from './client-init';
import HTML from './html';

export interface AppProps extends AppShellProps {
  /**
   * Indicates that the client ran into an error during hydration but is able to
   * recover. Some parts of the application may need to implement some special
   * handling of this case.
   */
  isClientRecovery?: boolean;
}

export const App = ({ isClientRecovery, ...props }: AppProps) => {
  const { title, description } = props.initialRouteContext ?? {};

  // Page component is included in the suspense fallback to ensure the shell
  // carries the Page styles from server to client, reducing turbulence on load.
  const loading = (
    <Page>
      <PageLoader />
    </Page>
  );

  return (
    <HTML
      title={`${title} - Anchore`}
      description={description}
      version={props.data.uiVersion}
      initialStyles={props.initialStyles}
      isClientRecovery={isClientRecovery}
    >
      <AppShell {...props}>
        {/* 👻 <-- ghost in the shell 🐚 */}
        <Suspense fallback={loading}>
          <RouteContainer />
        </Suspense>

        <ClientInit />
      </AppShell>
    </HTML>
  );
};

export default App;
